/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.4.0 (NJsonSchema v10.0.21.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { NgModule, Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
@NgModule()export class ServiceProxiesModule { }

@Injectable({
    providedIn: ServiceProxiesModule
})
export class CodeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param type (optional) 
     * @return Success
     */
    codeFindByType(type: Type | null | undefined): Observable<Code[]> {
        let url_ = this.baseUrl + "/api/Pfev/code/findByType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(type);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCodeFindByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCodeFindByType(<any>response_);
                } catch (e) {
                    return <Observable<Code[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Code[]>><any>_observableThrow(response_);
        }));
    }

    protected processCodeFindByType(response: HttpResponseBase): Observable<Code[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Code.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Code[]>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class ContactLogCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    contactLogCrudGet(id: string): Observable<ContactLogWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/contactLogCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactLogCrudGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactLogCrudGet(<any>response_);
                } catch (e) {
                    return <Observable<ContactLogWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContactLogWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processContactLogCrudGet(response: HttpResponseBase): Observable<ContactLogWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactLogWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactLogWithDetailsDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    contactLogCrudUpdate(id: string, input: ContactLogUpdateInput | null | undefined): Observable<ContactLogWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/contactLogCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactLogCrudUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactLogCrudUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ContactLogWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContactLogWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processContactLogCrudUpdate(response: HttpResponseBase): Observable<ContactLogWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactLogWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactLogWithDetailsDto>(<any>null);
    }

    /**
     * @return Success
     */
    contactLogCrudDelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/contactLogCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactLogCrudDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactLogCrudDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processContactLogCrudDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    contactLogCrudGetList(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfContactLogDto> {
        let url_ = this.baseUrl + "/api/Pfev/contactLogCrud?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactLogCrudGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactLogCrudGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfContactLogDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfContactLogDto>><any>_observableThrow(response_);
        }));
    }

    protected processContactLogCrudGetList(response: HttpResponseBase): Observable<PagedResultDtoOfContactLogDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfContactLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfContactLogDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    contactLogCrudCreate(input: ContactLogCreateInput | null | undefined): Observable<ContactLogWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/contactLogCrud";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContactLogCrudCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContactLogCrudCreate(<any>response_);
                } catch (e) {
                    return <Observable<ContactLogWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ContactLogWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processContactLogCrudCreate(response: HttpResponseBase): Observable<ContactLogWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactLogWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactLogWithDetailsDto>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class ElasticSearchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    elasticSearchResetIndex(): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/elasticSearch/resetIndex";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElasticSearchResetIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElasticSearchResetIndex(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processElasticSearchResetIndex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param queryString (optional) 
     * @return Success
     */
    elasticSearchSearch(queryString: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/elasticSearch/search?";
        if (queryString !== undefined)
            url_ += "queryString=" + encodeURIComponent("" + queryString) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElasticSearchSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElasticSearchSearch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processElasticSearchSearch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param queryString (optional) 
     * @return Success
     */
    elasticSearchExactSearch(queryString: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/elasticSearch/exactSearch?";
        if (queryString !== undefined)
            url_ += "queryString=" + encodeURIComponent("" + queryString) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processElasticSearchExactSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processElasticSearchExactSearch(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processElasticSearchExactSearch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class ExportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    exportExportProfessors(): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/ExportProfessors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExportProfessors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExportProfessors(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportExportProfessors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    exportExportPapers(): Observable<void> {
        let url_ = this.baseUrl + "/api/Export/ExportPapers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExportPapers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExportPapers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportExportPapers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    exportGetExportProfessorDatas(): Observable<GetExportProfessorDatasOutput> {
        let url_ = this.baseUrl + "/api/Pfev/export/exportProfessorDatas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGetExportProfessorDatas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGetExportProfessorDatas(<any>response_);
                } catch (e) {
                    return <Observable<GetExportProfessorDatasOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetExportProfessorDatasOutput>><any>_observableThrow(response_);
        }));
    }

    protected processExportGetExportProfessorDatas(response: HttpResponseBase): Observable<GetExportProfessorDatasOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExportProfessorDatasOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetExportProfessorDatasOutput>(<any>null);
    }

    /**
     * @return Success
     */
    exportGetExportPaperDatas(): Observable<ExportPapers[]> {
        let url_ = this.baseUrl + "/api/Pfev/export/exportPaperDatas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportGetExportPaperDatas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportGetExportPaperDatas(<any>response_);
                } catch (e) {
                    return <Observable<ExportPapers[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExportPapers[]>><any>_observableThrow(response_);
        }));
    }

    protected processExportGetExportPaperDatas(response: HttpResponseBase): Observable<ExportPapers[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExportPapers.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportPapers[]>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class NewsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    newsGetByAnonymous(keyword: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfNews> {
        let url_ = this.baseUrl + "/api/Pfev/news/byAnonymous?";
        if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsGetByAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsGetByAnonymous(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNews>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNews>><any>_observableThrow(response_);
        }));
    }

    protected processNewsGetByAnonymous(response: HttpResponseBase): Observable<PagedResultDtoOfNews> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNews.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNews>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class NewsCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    newsCrudGet(id: string): Observable<NewsWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/newsCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsCrudGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsCrudGet(<any>response_);
                } catch (e) {
                    return <Observable<NewsWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processNewsCrudGet(response: HttpResponseBase): Observable<NewsWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsWithDetailsDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    newsCrudUpdate(id: string, input: NewsUpdateInput | null | undefined): Observable<NewsWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/newsCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsCrudUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsCrudUpdate(<any>response_);
                } catch (e) {
                    return <Observable<NewsWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processNewsCrudUpdate(response: HttpResponseBase): Observable<NewsWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsWithDetailsDto>(<any>null);
    }

    /**
     * @return Success
     */
    newsCrudDelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/newsCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsCrudDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsCrudDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processNewsCrudDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    newsCrudGetList(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfNewsDto> {
        let url_ = this.baseUrl + "/api/Pfev/newsCrud?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsCrudGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsCrudGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNewsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNewsDto>><any>_observableThrow(response_);
        }));
    }

    protected processNewsCrudGetList(response: HttpResponseBase): Observable<PagedResultDtoOfNewsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNewsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNewsDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    newsCrudCreate(input: NewsCreateInput | null | undefined): Observable<NewsWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/newsCrud";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewsCrudCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewsCrudCreate(<any>response_);
                } catch (e) {
                    return <Observable<NewsWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NewsWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processNewsCrudCreate(response: HttpResponseBase): Observable<NewsWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewsWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewsWithDetailsDto>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class PaperServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param professorId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    paperGetProfessorPaper(professorId: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, keyword: string | null | undefined): Observable<PagedResultDtoOfGetProfessorPaperOutput> {
        let url_ = this.baseUrl + "/api/Pfev/paper/professorPaper?";
        if (professorId !== undefined)
            url_ += "ProfessorId=" + encodeURIComponent("" + professorId) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperGetProfessorPaper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperGetProfessorPaper(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProfessorPaperOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProfessorPaperOutput>><any>_observableThrow(response_);
        }));
    }

    protected processPaperGetProfessorPaper(response: HttpResponseBase): Observable<PagedResultDtoOfGetProfessorPaperOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProfessorPaperOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProfessorPaperOutput>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    paperGetSearchPaper(skipCount: number | null | undefined, maxResultCount: number | null | undefined, keyword: string | null | undefined): Observable<PagedResultDtoOfGetProfessorPaperOutput> {
        let url_ = this.baseUrl + "/api/Pfev/paper/searchPaper?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperGetSearchPaper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperGetSearchPaper(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetProfessorPaperOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetProfessorPaperOutput>><any>_observableThrow(response_);
        }));
    }

    protected processPaperGetSearchPaper(response: HttpResponseBase): Observable<PagedResultDtoOfGetProfessorPaperOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetProfessorPaperOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetProfessorPaperOutput>(<any>null);
    }

    /**
     * @return Success
     */
    paperGetPaperWithDetails(paperId: string): Observable<GetProfessorPaperOutput> {
        let url_ = this.baseUrl + "/api/Pfev/paper/paperWithDetails/{paperId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperGetPaperWithDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperGetPaperWithDetails(<any>response_);
                } catch (e) {
                    return <Observable<GetProfessorPaperOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetProfessorPaperOutput>><any>_observableThrow(response_);
        }));
    }

    protected processPaperGetPaperWithDetails(response: HttpResponseBase): Observable<GetProfessorPaperOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfessorPaperOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProfessorPaperOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    paperCreatePaperAndProfessor(input: PaperAndProfessorIds | null | undefined): Observable<PaperDto> {
        let url_ = this.baseUrl + "/api/Pfev/paper/paperAndProfessor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperCreatePaperAndProfessor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperCreatePaperAndProfessor(<any>response_);
                } catch (e) {
                    return <Observable<PaperDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaperDto>><any>_observableThrow(response_);
        }));
    }

    protected processPaperCreatePaperAndProfessor(response: HttpResponseBase): Observable<PaperDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaperDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    paperUpdatePaperAndProfessor(id: string, input: PaperAndProfessorIds | null | undefined): Observable<PaperDto> {
        let url_ = this.baseUrl + "/api/Pfev/paper/{id}/paperAndProfessor";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperUpdatePaperAndProfessor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperUpdatePaperAndProfessor(<any>response_);
                } catch (e) {
                    return <Observable<PaperDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaperDto>><any>_observableThrow(response_);
        }));
    }

    protected processPaperUpdatePaperAndProfessor(response: HttpResponseBase): Observable<PaperDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaperDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    paperPostGetPaperUrl(input: PostGetPaperUrl | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Pfev/paper/getPaperUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperPostGetPaperUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperPostGetPaperUrl(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPaperPostGetPaperUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class PaperCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    paperCrudGet(id: string): Observable<PaperWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/paperCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperCrudGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperCrudGet(<any>response_);
                } catch (e) {
                    return <Observable<PaperWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaperWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processPaperCrudGet(response: HttpResponseBase): Observable<PaperWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaperWithDetailsDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    paperCrudUpdate(id: string, input: PaperUpdateInput | null | undefined): Observable<PaperWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/paperCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperCrudUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperCrudUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PaperWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaperWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processPaperCrudUpdate(response: HttpResponseBase): Observable<PaperWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaperWithDetailsDto>(<any>null);
    }

    /**
     * @return Success
     */
    paperCrudDelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/paperCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperCrudDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperCrudDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPaperCrudDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    paperCrudGetList(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfPaperDto> {
        let url_ = this.baseUrl + "/api/Pfev/paperCrud?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperCrudGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperCrudGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPaperDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPaperDto>><any>_observableThrow(response_);
        }));
    }

    protected processPaperCrudGetList(response: HttpResponseBase): Observable<PagedResultDtoOfPaperDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPaperDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPaperDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    paperCrudCreate(input: PaperCreateInput | null | undefined): Observable<PaperWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/paperCrud";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaperCrudCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaperCrudCreate(<any>response_);
                } catch (e) {
                    return <Observable<PaperWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaperWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processPaperCrudCreate(response: HttpResponseBase): Observable<PaperWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaperWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaperWithDetailsDto>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class PatentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param professorId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    patentGetProfessorPatent(professorId: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, keyword: string | null | undefined): Observable<PagedResultDtoOfPatentDto> {
        let url_ = this.baseUrl + "/api/Pfev/patent/professorPatent?";
        if (professorId !== undefined)
            url_ += "ProfessorId=" + encodeURIComponent("" + professorId) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatentGetProfessorPatent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatentGetProfessorPatent(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPatentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPatentDto>><any>_observableThrow(response_);
        }));
    }

    protected processPatentGetProfessorPatent(response: HttpResponseBase): Observable<PagedResultDtoOfPatentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPatentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPatentDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    patentPostGetPatentNo(input: PostGetPatentUrl | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Pfev/patent/getPatentNo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatentPostGetPatentNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatentPostGetPatentNo(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processPatentPostGetPatentNo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class PatentCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    patentCrudGetList(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfPatentDto> {
        let url_ = this.baseUrl + "/api/Pfev/patentCrud?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatentCrudGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatentCrudGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPatentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPatentDto>><any>_observableThrow(response_);
        }));
    }

    protected processPatentCrudGetList(response: HttpResponseBase): Observable<PagedResultDtoOfPatentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPatentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPatentDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    patentCrudCreate(input: PatentCreateInput | null | undefined): Observable<PatentWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/patentCrud";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatentCrudCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatentCrudCreate(<any>response_);
                } catch (e) {
                    return <Observable<PatentWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatentWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processPatentCrudCreate(response: HttpResponseBase): Observable<PatentWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatentWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatentWithDetailsDto>(<any>null);
    }

    /**
     * @return Success
     */
    patentCrudGet(id: string): Observable<PatentWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/patentCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatentCrudGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatentCrudGet(<any>response_);
                } catch (e) {
                    return <Observable<PatentWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatentWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processPatentCrudGet(response: HttpResponseBase): Observable<PatentWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatentWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatentWithDetailsDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    patentCrudUpdate(id: string, input: PatentUpdateInput | null | undefined): Observable<PatentWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/patentCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatentCrudUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatentCrudUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PatentWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PatentWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processPatentCrudUpdate(response: HttpResponseBase): Observable<PatentWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PatentWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PatentWithDetailsDto>(<any>null);
    }

    /**
     * @return Success
     */
    patentCrudDelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/patentCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatentCrudDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatentCrudDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPatentCrudDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class ProfessorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    professorGetSearchProfessor(skipCount: number | null | undefined, maxResultCount: number | null | undefined, keyword: string | null | undefined): Observable<PagedResultDtoOfProfessorDto> {
        let url_ = this.baseUrl + "/api/Pfev/professor/searchProfessor?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfessorGetSearchProfessor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfessorGetSearchProfessor(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProfessorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProfessorDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfessorGetSearchProfessor(response: HttpResponseBase): Observable<PagedResultDtoOfProfessorDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProfessorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProfessorDto>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class ProfessorCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    professorCrudGet(id: string): Observable<ProfessorWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/professorCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfessorCrudGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfessorCrudGet(<any>response_);
                } catch (e) {
                    return <Observable<ProfessorWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfessorWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfessorCrudGet(response: HttpResponseBase): Observable<ProfessorWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessorWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessorWithDetailsDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    professorCrudUpdate(id: string, input: ProfessorUpdateInput | null | undefined): Observable<ProfessorWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/professorCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfessorCrudUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfessorCrudUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ProfessorWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfessorWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfessorCrudUpdate(response: HttpResponseBase): Observable<ProfessorWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessorWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessorWithDetailsDto>(<any>null);
    }

    /**
     * @return Success
     */
    professorCrudDelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/professorCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfessorCrudDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfessorCrudDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProfessorCrudDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    professorCrudGetList(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProfessorDto> {
        let url_ = this.baseUrl + "/api/Pfev/professorCrud?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfessorCrudGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfessorCrudGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProfessorDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProfessorDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfessorCrudGetList(response: HttpResponseBase): Observable<PagedResultDtoOfProfessorDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProfessorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProfessorDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    professorCrudCreate(input: ProfessorCreateInput | null | undefined): Observable<ProfessorWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/professorCrud";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfessorCrudCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfessorCrudCreate(<any>response_);
                } catch (e) {
                    return <Observable<ProfessorWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProfessorWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProfessorCrudCreate(response: HttpResponseBase): Observable<ProfessorWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessorWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessorWithDetailsDto>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class ProjectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param professorId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    projectGetProfessorProjects(professorId: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, keyword: string | null | undefined): Observable<PagedResultDtoOfProjectDto> {
        let url_ = this.baseUrl + "/api/Pfev/project/professorProjects?";
        if (professorId !== undefined)
            url_ += "ProfessorId=" + encodeURIComponent("" + professorId) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectGetProfessorProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectGetProfessorProjects(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processProjectGetProfessorProjects(response: HttpResponseBase): Observable<PagedResultDtoOfProjectDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProjectDto>(<any>null);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    projectGetNoRelationProjects(skipCount: number | null | undefined, maxResultCount: number | null | undefined, keyword: string | null | undefined): Observable<PagedResultDtoOfGetNoRelationProjectsOutput> {
        let url_ = this.baseUrl + "/api/Pfev/project/noRelationProjects?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectGetNoRelationProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectGetNoRelationProjects(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetNoRelationProjectsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetNoRelationProjectsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processProjectGetNoRelationProjects(response: HttpResponseBase): Observable<PagedResultDtoOfGetNoRelationProjectsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetNoRelationProjectsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetNoRelationProjectsOutput>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class ProjectCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    projectCrudGet(id: string): Observable<ProjectWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/projectCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCrudGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCrudGet(<any>response_);
                } catch (e) {
                    return <Observable<ProjectWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProjectCrudGet(response: HttpResponseBase): Observable<ProjectWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectWithDetailsDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    projectCrudUpdate(id: string, input: ProjectUpdateInput | null | undefined): Observable<ProjectWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/projectCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCrudUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCrudUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ProjectWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProjectCrudUpdate(response: HttpResponseBase): Observable<ProjectWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectWithDetailsDto>(<any>null);
    }

    /**
     * @return Success
     */
    projectCrudDelete(id: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/projectCrud/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCrudDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCrudDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processProjectCrudDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    projectCrudGetList(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfProjectDto> {
        let url_ = this.baseUrl + "/api/Pfev/projectCrud?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCrudGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCrudGetList(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfProjectDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfProjectDto>><any>_observableThrow(response_);
        }));
    }

    protected processProjectCrudGetList(response: HttpResponseBase): Observable<PagedResultDtoOfProjectDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfProjectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfProjectDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    projectCrudCreate(input: ProjectCreateInput | null | undefined): Observable<ProjectWithDetailsDto> {
        let url_ = this.baseUrl + "/api/Pfev/projectCrud";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProjectCrudCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProjectCrudCreate(<any>response_);
                } catch (e) {
                    return <Observable<ProjectWithDetailsDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ProjectWithDetailsDto>><any>_observableThrow(response_);
        }));
    }

    protected processProjectCrudCreate(response: HttpResponseBase): Observable<ProjectWithDetailsDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectWithDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectWithDetailsDto>(<any>null);
    }
}

@Injectable({
    providedIn: ServiceProxiesModule
})
export class SampleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    sampleGet(): Observable<SampleDto> {
        let url_ = this.baseUrl + "/api/Pfev/sample";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSampleGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSampleGet(<any>response_);
                } catch (e) {
                    return <Observable<SampleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SampleDto>><any>_observableThrow(response_);
        }));
    }

    protected processSampleGet(response: HttpResponseBase): Observable<SampleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SampleDto>(<any>null);
    }

    /**
     * @return Success
     */
    sampleGetAuthorized(): Observable<SampleDto> {
        let url_ = this.baseUrl + "/api/Pfev/sample/authorized";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSampleGetAuthorized(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSampleGetAuthorized(<any>response_);
                } catch (e) {
                    return <Observable<SampleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SampleDto>><any>_observableThrow(response_);
        }));
    }

    protected processSampleGetAuthorized(response: HttpResponseBase): Observable<SampleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SampleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SampleDto>(<any>null);
    }

    /**
     * @return Success
     */
    sampleImportTeachers(): Observable<void> {
        let url_ = this.baseUrl + "/api/Pfev/sample/importTeachers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSampleImportTeachers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSampleImportTeachers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSampleImportTeachers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class Code implements ICode {
    sequence!: number | undefined;
    codeType!: CodeType | undefined;
    text!: string | undefined;
    value!: string | undefined;
    tenantId!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    readonly extraProperties!: { [key: string] : any; } | undefined;
    concurrencyStamp!: string | undefined;
    id!: string | undefined;

    constructor(data?: ICode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sequence = data["sequence"];
            this.codeType = data["codeType"];
            this.text = data["text"];
            this.value = data["value"];
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            if (data["extraProperties"]) {
                (<any>this).extraProperties = {} as any;
                for (let key in data["extraProperties"]) {
                    if (data["extraProperties"].hasOwnProperty(key))
                        (<any>this).extraProperties![key] = data["extraProperties"][key];
                }
            }
            this.concurrencyStamp = data["concurrencyStamp"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): Code {
        data = typeof data === 'object' ? data : {};
        let result = new Code();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sequence"] = this.sequence;
        data["codeType"] = this.codeType;
        data["text"] = this.text;
        data["value"] = this.value;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        if (this.extraProperties) {
            data["extraProperties"] = {};
            for (let key in this.extraProperties) {
                if (this.extraProperties.hasOwnProperty(key))
                    data["extraProperties"][key] = this.extraProperties[key];
            }
        }
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["id"] = this.id;
        return data; 
    }

    clone(): Code {
        const json = this.toJSON();
        let result = new Code();
        result.init(json);
        return result;
    }
}

export interface ICode {
    sequence: number | undefined;
    codeType: CodeType | undefined;
    text: string | undefined;
    value: string | undefined;
    tenantId: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    extraProperties: { [key: string] : any; } | undefined;
    concurrencyStamp: string | undefined;
    id: string | undefined;
}

export class ContactLogWithDetailsDto implements IContactLogWithDetailsDto {
    name!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    description!: string | undefined;
    isConfirm!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IContactLogWithDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.description = data["description"];
            this.isConfirm = data["isConfirm"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactLogWithDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactLogWithDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["description"] = this.description;
        data["isConfirm"] = this.isConfirm;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ContactLogWithDetailsDto {
        const json = this.toJSON();
        let result = new ContactLogWithDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IContactLogWithDetailsDto {
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    description: string | undefined;
    isConfirm: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class ContactLogUpdateInput implements IContactLogUpdateInput {
    name!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    description!: string | undefined;
    isConfirm!: boolean | undefined;

    constructor(data?: IContactLogUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.description = data["description"];
            this.isConfirm = data["isConfirm"];
        }
    }

    static fromJS(data: any): ContactLogUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ContactLogUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["description"] = this.description;
        data["isConfirm"] = this.isConfirm;
        return data; 
    }

    clone(): ContactLogUpdateInput {
        const json = this.toJSON();
        let result = new ContactLogUpdateInput();
        result.init(json);
        return result;
    }
}

export interface IContactLogUpdateInput {
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    description: string | undefined;
    isConfirm: boolean | undefined;
}

export class PagedResultDtoOfContactLogDto implements IPagedResultDtoOfContactLogDto {
    totalCount!: number | undefined;
    items!: ContactLogDto[] | undefined;

    constructor(data?: IPagedResultDtoOfContactLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ContactLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfContactLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfContactLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfContactLogDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfContactLogDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfContactLogDto {
    totalCount: number | undefined;
    items: ContactLogDto[] | undefined;
}

export class ContactLogDto implements IContactLogDto {
    name!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    description!: string | undefined;
    isConfirm!: boolean | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IContactLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.description = data["description"];
            this.isConfirm = data["isConfirm"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ContactLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["description"] = this.description;
        data["isConfirm"] = this.isConfirm;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ContactLogDto {
        const json = this.toJSON();
        let result = new ContactLogDto();
        result.init(json);
        return result;
    }
}

export interface IContactLogDto {
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    description: string | undefined;
    isConfirm: boolean | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class ContactLogCreateInput implements IContactLogCreateInput {
    name!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    description!: string | undefined;
    isConfirm!: boolean | undefined;

    constructor(data?: IContactLogCreateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.email = data["email"];
            this.phone = data["phone"];
            this.description = data["description"];
            this.isConfirm = data["isConfirm"];
        }
    }

    static fromJS(data: any): ContactLogCreateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ContactLogCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["description"] = this.description;
        data["isConfirm"] = this.isConfirm;
        return data; 
    }

    clone(): ContactLogCreateInput {
        const json = this.toJSON();
        let result = new ContactLogCreateInput();
        result.init(json);
        return result;
    }
}

export interface IContactLogCreateInput {
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    description: string | undefined;
    isConfirm: boolean | undefined;
}

export class GetExportProfessorDatasOutput implements IGetExportProfessorDatasOutput {
    professors!: ExportProfessors[] | undefined;
    projects!: ExportProjects[] | undefined;
    patents!: ExportPatents[] | undefined;

    constructor(data?: IGetExportProfessorDatasOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["professors"])) {
                this.professors = [] as any;
                for (let item of data["professors"])
                    this.professors!.push(ExportProfessors.fromJS(item));
            }
            if (Array.isArray(data["projects"])) {
                this.projects = [] as any;
                for (let item of data["projects"])
                    this.projects!.push(ExportProjects.fromJS(item));
            }
            if (Array.isArray(data["patents"])) {
                this.patents = [] as any;
                for (let item of data["patents"])
                    this.patents!.push(ExportPatents.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetExportProfessorDatasOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExportProfessorDatasOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.professors)) {
            data["professors"] = [];
            for (let item of this.professors)
                data["professors"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.patents)) {
            data["patents"] = [];
            for (let item of this.patents)
                data["patents"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetExportProfessorDatasOutput {
        const json = this.toJSON();
        let result = new GetExportProfessorDatasOutput();
        result.init(json);
        return result;
    }
}

export interface IGetExportProfessorDatasOutput {
    professors: ExportProfessors[] | undefined;
    projects: ExportProjects[] | undefined;
    patents: ExportPatents[] | undefined;
}

export class ExportProfessors implements IExportProfessors {
    id!: string | undefined;
    college!: string | undefined;
    department!: string | undefined;
    classify!: string | undefined;
    title!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    fax!: string | undefined;
    email!: string | undefined;
    specialized!: string | undefined;

    constructor(data?: IExportProfessors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.college = data["college"];
            this.department = data["department"];
            this.classify = data["classify"];
            this.title = data["title"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.fax = data["fax"];
            this.email = data["email"];
            this.specialized = data["specialized"];
        }
    }

    static fromJS(data: any): ExportProfessors {
        data = typeof data === 'object' ? data : {};
        let result = new ExportProfessors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["college"] = this.college;
        data["department"] = this.department;
        data["classify"] = this.classify;
        data["title"] = this.title;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["specialized"] = this.specialized;
        return data; 
    }

    clone(): ExportProfessors {
        const json = this.toJSON();
        let result = new ExportProfessors();
        result.init(json);
        return result;
    }
}

export interface IExportProfessors {
    id: string | undefined;
    college: string | undefined;
    department: string | undefined;
    classify: string | undefined;
    title: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    specialized: string | undefined;
}

export class ExportProjects implements IExportProjects {
    id!: string | undefined;
    name!: string | undefined;
    year!: string | undefined;
    professorName!: string | undefined;

    constructor(data?: IExportProjects) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.year = data["year"];
            this.professorName = data["professorName"];
        }
    }

    static fromJS(data: any): ExportProjects {
        data = typeof data === 'object' ? data : {};
        let result = new ExportProjects();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["year"] = this.year;
        data["professorName"] = this.professorName;
        return data; 
    }

    clone(): ExportProjects {
        const json = this.toJSON();
        let result = new ExportProjects();
        result.init(json);
        return result;
    }
}

export interface IExportProjects {
    id: string | undefined;
    name: string | undefined;
    year: string | undefined;
    professorName: string | undefined;
}

export class ExportPatents implements IExportPatents {
    id!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    country!: string | undefined;
    validStartTime!: Date | undefined;
    validEndTime!: Date | undefined;
    valueYear!: string | undefined;
    professorName!: string | undefined;

    constructor(data?: IExportPatents) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.type = data["type"];
            this.country = data["country"];
            this.validStartTime = data["validStartTime"] ? new Date(data["validStartTime"].toString()) : <any>undefined;
            this.validEndTime = data["validEndTime"] ? new Date(data["validEndTime"].toString()) : <any>undefined;
            this.valueYear = data["valueYear"];
            this.professorName = data["professorName"];
        }
    }

    static fromJS(data: any): ExportPatents {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPatents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["country"] = this.country;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : <any>undefined;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : <any>undefined;
        data["valueYear"] = this.valueYear;
        data["professorName"] = this.professorName;
        return data; 
    }

    clone(): ExportPatents {
        const json = this.toJSON();
        let result = new ExportPatents();
        result.init(json);
        return result;
    }
}

export interface IExportPatents {
    id: string | undefined;
    name: string | undefined;
    type: string | undefined;
    country: string | undefined;
    validStartTime: Date | undefined;
    validEndTime: Date | undefined;
    valueYear: string | undefined;
    professorName: string | undefined;
}

export class ExportPapers implements IExportPapers {
    id!: string | undefined;
    title!: string | undefined;
    adviser!: string | undefined;
    publicationYear!: string | undefined;
    academicYear!: string | undefined;

    constructor(data?: IExportPapers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.title = data["title"];
            this.adviser = data["adviser"];
            this.publicationYear = data["publicationYear"];
            this.academicYear = data["academicYear"];
        }
    }

    static fromJS(data: any): ExportPapers {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPapers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["adviser"] = this.adviser;
        data["publicationYear"] = this.publicationYear;
        data["academicYear"] = this.academicYear;
        return data; 
    }

    clone(): ExportPapers {
        const json = this.toJSON();
        let result = new ExportPapers();
        result.init(json);
        return result;
    }
}

export interface IExportPapers {
    id: string | undefined;
    title: string | undefined;
    adviser: string | undefined;
    publicationYear: string | undefined;
    academicYear: string | undefined;
}

export class PagedResultDtoOfNews implements IPagedResultDtoOfNews {
    totalCount!: number | undefined;
    items!: News[] | undefined;

    constructor(data?: IPagedResultDtoOfNews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(News.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNews {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNews();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfNews {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNews();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNews {
    totalCount: number | undefined;
    items: News[] | undefined;
}

export class News implements INews {
    title!: string | undefined;
    subtitle!: string | undefined;
    description!: string | undefined;
    publish!: boolean | undefined;
    publish_At!: Date | undefined;
    tenantId!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    readonly extraProperties!: { [key: string] : any; } | undefined;
    concurrencyStamp!: string | undefined;
    id!: string | undefined;

    constructor(data?: INews) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.publish = data["publish"];
            this.publish_At = data["publish_At"] ? new Date(data["publish_At"].toString()) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            if (data["extraProperties"]) {
                (<any>this).extraProperties = {} as any;
                for (let key in data["extraProperties"]) {
                    if (data["extraProperties"].hasOwnProperty(key))
                        (<any>this).extraProperties![key] = data["extraProperties"][key];
                }
            }
            this.concurrencyStamp = data["concurrencyStamp"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): News {
        data = typeof data === 'object' ? data : {};
        let result = new News();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["publish"] = this.publish;
        data["publish_At"] = this.publish_At ? this.publish_At.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        if (this.extraProperties) {
            data["extraProperties"] = {};
            for (let key in this.extraProperties) {
                if (this.extraProperties.hasOwnProperty(key))
                    data["extraProperties"][key] = this.extraProperties[key];
            }
        }
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["id"] = this.id;
        return data; 
    }

    clone(): News {
        const json = this.toJSON();
        let result = new News();
        result.init(json);
        return result;
    }
}

export interface INews {
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    publish: boolean | undefined;
    publish_At: Date | undefined;
    tenantId: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    extraProperties: { [key: string] : any; } | undefined;
    concurrencyStamp: string | undefined;
    id: string | undefined;
}

export class NewsWithDetailsDto implements INewsWithDetailsDto {
    title!: string | undefined;
    subtitle!: string | undefined;
    description!: string | undefined;
    publish!: boolean | undefined;
    publish_At!: Date | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: INewsWithDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.publish = data["publish"];
            this.publish_At = data["publish_At"] ? new Date(data["publish_At"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NewsWithDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsWithDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["publish"] = this.publish;
        data["publish_At"] = this.publish_At ? this.publish_At.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): NewsWithDetailsDto {
        const json = this.toJSON();
        let result = new NewsWithDetailsDto();
        result.init(json);
        return result;
    }
}

export interface INewsWithDetailsDto {
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    publish: boolean | undefined;
    publish_At: Date | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class NewsUpdateInput implements INewsUpdateInput {
    title!: string | undefined;
    subtitle!: string | undefined;
    description!: string | undefined;
    publish!: boolean | undefined;
    publish_At!: Date | undefined;

    constructor(data?: INewsUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.publish = data["publish"];
            this.publish_At = data["publish_At"] ? new Date(data["publish_At"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NewsUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new NewsUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["publish"] = this.publish;
        data["publish_At"] = this.publish_At ? this.publish_At.toISOString() : <any>undefined;
        return data; 
    }

    clone(): NewsUpdateInput {
        const json = this.toJSON();
        let result = new NewsUpdateInput();
        result.init(json);
        return result;
    }
}

export interface INewsUpdateInput {
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    publish: boolean | undefined;
    publish_At: Date | undefined;
}

export class PagedResultDtoOfNewsDto implements IPagedResultDtoOfNewsDto {
    totalCount!: number | undefined;
    items!: NewsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(NewsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfNewsDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNewsDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNewsDto {
    totalCount: number | undefined;
    items: NewsDto[] | undefined;
}

export class NewsDto implements INewsDto {
    title!: string | undefined;
    subtitle!: string | undefined;
    description!: string | undefined;
    publish!: boolean | undefined;
    publish_At!: Date | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: INewsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.publish = data["publish"];
            this.publish_At = data["publish_At"] ? new Date(data["publish_At"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NewsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["publish"] = this.publish;
        data["publish_At"] = this.publish_At ? this.publish_At.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): NewsDto {
        const json = this.toJSON();
        let result = new NewsDto();
        result.init(json);
        return result;
    }
}

export interface INewsDto {
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    publish: boolean | undefined;
    publish_At: Date | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class NewsCreateInput implements INewsCreateInput {
    title!: string | undefined;
    subtitle!: string | undefined;
    description!: string | undefined;
    publish!: boolean | undefined;
    publish_At!: Date | undefined;

    constructor(data?: INewsCreateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.subtitle = data["subtitle"];
            this.description = data["description"];
            this.publish = data["publish"];
            this.publish_At = data["publish_At"] ? new Date(data["publish_At"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NewsCreateInput {
        data = typeof data === 'object' ? data : {};
        let result = new NewsCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["description"] = this.description;
        data["publish"] = this.publish;
        data["publish_At"] = this.publish_At ? this.publish_At.toISOString() : <any>undefined;
        return data; 
    }

    clone(): NewsCreateInput {
        const json = this.toJSON();
        let result = new NewsCreateInput();
        result.init(json);
        return result;
    }
}

export interface INewsCreateInput {
    title: string | undefined;
    subtitle: string | undefined;
    description: string | undefined;
    publish: boolean | undefined;
    publish_At: Date | undefined;
}

export class PagedResultDtoOfGetProfessorPaperOutput implements IPagedResultDtoOfGetProfessorPaperOutput {
    totalCount!: number | undefined;
    items!: GetProfessorPaperOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetProfessorPaperOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetProfessorPaperOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetProfessorPaperOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetProfessorPaperOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetProfessorPaperOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetProfessorPaperOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetProfessorPaperOutput {
    totalCount: number | undefined;
    items: GetProfessorPaperOutput[] | undefined;
}

export class GetProfessorPaperOutput implements IGetProfessorPaperOutput {
    professors!: ProfessorDto[] | undefined;
    region!: string | undefined;
    department!: string | undefined;
    no!: string | undefined;
    chineseTitle!: string | undefined;
    englishTitle!: string | undefined;
    adviser!: string | undefined;
    academicYear!: string | undefined;
    publicationYear!: string | undefined;
    url!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IGetProfessorPaperOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["professors"])) {
                this.professors = [] as any;
                for (let item of data["professors"])
                    this.professors!.push(ProfessorDto.fromJS(item));
            }
            this.region = data["region"];
            this.department = data["department"];
            this.no = data["no"];
            this.chineseTitle = data["chineseTitle"];
            this.englishTitle = data["englishTitle"];
            this.adviser = data["adviser"];
            this.academicYear = data["academicYear"];
            this.publicationYear = data["publicationYear"];
            this.url = data["url"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetProfessorPaperOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfessorPaperOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.professors)) {
            data["professors"] = [];
            for (let item of this.professors)
                data["professors"].push(item.toJSON());
        }
        data["region"] = this.region;
        data["department"] = this.department;
        data["no"] = this.no;
        data["chineseTitle"] = this.chineseTitle;
        data["englishTitle"] = this.englishTitle;
        data["adviser"] = this.adviser;
        data["academicYear"] = this.academicYear;
        data["publicationYear"] = this.publicationYear;
        data["url"] = this.url;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): GetProfessorPaperOutput {
        const json = this.toJSON();
        let result = new GetProfessorPaperOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProfessorPaperOutput {
    professors: ProfessorDto[] | undefined;
    region: string | undefined;
    department: string | undefined;
    no: string | undefined;
    chineseTitle: string | undefined;
    englishTitle: string | undefined;
    adviser: string | undefined;
    academicYear: string | undefined;
    publicationYear: string | undefined;
    url: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class ProfessorDto implements IProfessorDto {
    collegeId!: string | undefined;
    departmentId!: string | undefined;
    classifyId!: string | undefined;
    titleId!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    extension!: string | undefined;
    fax!: string | undefined;
    email!: string | undefined;
    specialized!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IProfessorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collegeId = data["collegeId"];
            this.departmentId = data["departmentId"];
            this.classifyId = data["classifyId"];
            this.titleId = data["titleId"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.extension = data["extension"];
            this.fax = data["fax"];
            this.email = data["email"];
            this.specialized = data["specialized"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProfessorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collegeId"] = this.collegeId;
        data["departmentId"] = this.departmentId;
        data["classifyId"] = this.classifyId;
        data["titleId"] = this.titleId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["specialized"] = this.specialized;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProfessorDto {
        const json = this.toJSON();
        let result = new ProfessorDto();
        result.init(json);
        return result;
    }
}

export interface IProfessorDto {
    collegeId: string | undefined;
    departmentId: string | undefined;
    classifyId: string | undefined;
    titleId: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    extension: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    specialized: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class PaperAndProfessorIds implements IPaperAndProfessorIds {
    professorIds!: string[] | undefined;
    region!: string | undefined;
    department!: string | undefined;
    no!: string | undefined;
    chineseTitle!: string | undefined;
    englishTitle!: string | undefined;
    adviser!: string | undefined;
    academicYear!: string | undefined;
    publicationYear!: string | undefined;
    url!: string | undefined;

    constructor(data?: IPaperAndProfessorIds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["professorIds"])) {
                this.professorIds = [] as any;
                for (let item of data["professorIds"])
                    this.professorIds!.push(item);
            }
            this.region = data["region"];
            this.department = data["department"];
            this.no = data["no"];
            this.chineseTitle = data["chineseTitle"];
            this.englishTitle = data["englishTitle"];
            this.adviser = data["adviser"];
            this.academicYear = data["academicYear"];
            this.publicationYear = data["publicationYear"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): PaperAndProfessorIds {
        data = typeof data === 'object' ? data : {};
        let result = new PaperAndProfessorIds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.professorIds)) {
            data["professorIds"] = [];
            for (let item of this.professorIds)
                data["professorIds"].push(item);
        }
        data["region"] = this.region;
        data["department"] = this.department;
        data["no"] = this.no;
        data["chineseTitle"] = this.chineseTitle;
        data["englishTitle"] = this.englishTitle;
        data["adviser"] = this.adviser;
        data["academicYear"] = this.academicYear;
        data["publicationYear"] = this.publicationYear;
        data["url"] = this.url;
        return data; 
    }

    clone(): PaperAndProfessorIds {
        const json = this.toJSON();
        let result = new PaperAndProfessorIds();
        result.init(json);
        return result;
    }
}

export interface IPaperAndProfessorIds {
    professorIds: string[] | undefined;
    region: string | undefined;
    department: string | undefined;
    no: string | undefined;
    chineseTitle: string | undefined;
    englishTitle: string | undefined;
    adviser: string | undefined;
    academicYear: string | undefined;
    publicationYear: string | undefined;
    url: string | undefined;
}

export class PaperDto implements IPaperDto {
    region!: string | undefined;
    department!: string | undefined;
    no!: string | undefined;
    chineseTitle!: string | undefined;
    englishTitle!: string | undefined;
    adviser!: string | undefined;
    academicYear!: string | undefined;
    publicationYear!: string | undefined;
    url!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IPaperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.region = data["region"];
            this.department = data["department"];
            this.no = data["no"];
            this.chineseTitle = data["chineseTitle"];
            this.englishTitle = data["englishTitle"];
            this.adviser = data["adviser"];
            this.academicYear = data["academicYear"];
            this.publicationYear = data["publicationYear"];
            this.url = data["url"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaperDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["department"] = this.department;
        data["no"] = this.no;
        data["chineseTitle"] = this.chineseTitle;
        data["englishTitle"] = this.englishTitle;
        data["adviser"] = this.adviser;
        data["academicYear"] = this.academicYear;
        data["publicationYear"] = this.publicationYear;
        data["url"] = this.url;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PaperDto {
        const json = this.toJSON();
        let result = new PaperDto();
        result.init(json);
        return result;
    }
}

export interface IPaperDto {
    region: string | undefined;
    department: string | undefined;
    no: string | undefined;
    chineseTitle: string | undefined;
    englishTitle: string | undefined;
    adviser: string | undefined;
    academicYear: string | undefined;
    publicationYear: string | undefined;
    url: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class PostGetPaperUrl implements IPostGetPaperUrl {
    professorId!: string | undefined;
    paperName!: string | undefined;

    constructor(data?: IPostGetPaperUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professorId = data["professorId"];
            this.paperName = data["paperName"];
        }
    }

    static fromJS(data: any): PostGetPaperUrl {
        data = typeof data === 'object' ? data : {};
        let result = new PostGetPaperUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professorId"] = this.professorId;
        data["paperName"] = this.paperName;
        return data; 
    }

    clone(): PostGetPaperUrl {
        const json = this.toJSON();
        let result = new PostGetPaperUrl();
        result.init(json);
        return result;
    }
}

export interface IPostGetPaperUrl {
    professorId: string | undefined;
    paperName: string | undefined;
}

export class PaperWithDetailsDto implements IPaperWithDetailsDto {
    professorPapers!: ProfessorPaperDto[] | undefined;
    region!: string | undefined;
    department!: string | undefined;
    no!: string | undefined;
    chineseTitle!: string | undefined;
    englishTitle!: string | undefined;
    adviser!: string | undefined;
    academicYear!: string | undefined;
    publicationYear!: string | undefined;
    url!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IPaperWithDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["professorPapers"])) {
                this.professorPapers = [] as any;
                for (let item of data["professorPapers"])
                    this.professorPapers!.push(ProfessorPaperDto.fromJS(item));
            }
            this.region = data["region"];
            this.department = data["department"];
            this.no = data["no"];
            this.chineseTitle = data["chineseTitle"];
            this.englishTitle = data["englishTitle"];
            this.adviser = data["adviser"];
            this.academicYear = data["academicYear"];
            this.publicationYear = data["publicationYear"];
            this.url = data["url"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PaperWithDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaperWithDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.professorPapers)) {
            data["professorPapers"] = [];
            for (let item of this.professorPapers)
                data["professorPapers"].push(item.toJSON());
        }
        data["region"] = this.region;
        data["department"] = this.department;
        data["no"] = this.no;
        data["chineseTitle"] = this.chineseTitle;
        data["englishTitle"] = this.englishTitle;
        data["adviser"] = this.adviser;
        data["academicYear"] = this.academicYear;
        data["publicationYear"] = this.publicationYear;
        data["url"] = this.url;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PaperWithDetailsDto {
        const json = this.toJSON();
        let result = new PaperWithDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IPaperWithDetailsDto {
    professorPapers: ProfessorPaperDto[] | undefined;
    region: string | undefined;
    department: string | undefined;
    no: string | undefined;
    chineseTitle: string | undefined;
    englishTitle: string | undefined;
    adviser: string | undefined;
    academicYear: string | undefined;
    publicationYear: string | undefined;
    url: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class ProfessorPaperDto implements IProfessorPaperDto {
    professorId!: string | undefined;
    paperId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IProfessorPaperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professorId = data["professorId"];
            this.paperId = data["paperId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProfessorPaperDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessorPaperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professorId"] = this.professorId;
        data["paperId"] = this.paperId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProfessorPaperDto {
        const json = this.toJSON();
        let result = new ProfessorPaperDto();
        result.init(json);
        return result;
    }
}

export interface IProfessorPaperDto {
    professorId: string | undefined;
    paperId: string | undefined;
    id: string | undefined;
}

export class PaperUpdateInput implements IPaperUpdateInput {
    region!: string | undefined;
    department!: string | undefined;
    no!: string | undefined;
    chineseTitle!: string | undefined;
    englishTitle!: string | undefined;
    adviser!: string | undefined;
    academicYear!: string | undefined;
    publicationYear!: string | undefined;
    url!: string | undefined;

    constructor(data?: IPaperUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.region = data["region"];
            this.department = data["department"];
            this.no = data["no"];
            this.chineseTitle = data["chineseTitle"];
            this.englishTitle = data["englishTitle"];
            this.adviser = data["adviser"];
            this.academicYear = data["academicYear"];
            this.publicationYear = data["publicationYear"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): PaperUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new PaperUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["department"] = this.department;
        data["no"] = this.no;
        data["chineseTitle"] = this.chineseTitle;
        data["englishTitle"] = this.englishTitle;
        data["adviser"] = this.adviser;
        data["academicYear"] = this.academicYear;
        data["publicationYear"] = this.publicationYear;
        data["url"] = this.url;
        return data; 
    }

    clone(): PaperUpdateInput {
        const json = this.toJSON();
        let result = new PaperUpdateInput();
        result.init(json);
        return result;
    }
}

export interface IPaperUpdateInput {
    region: string | undefined;
    department: string | undefined;
    no: string | undefined;
    chineseTitle: string | undefined;
    englishTitle: string | undefined;
    adviser: string | undefined;
    academicYear: string | undefined;
    publicationYear: string | undefined;
    url: string | undefined;
}

export class PagedResultDtoOfPaperDto implements IPagedResultDtoOfPaperDto {
    totalCount!: number | undefined;
    items!: PaperDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPaperDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PaperDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPaperDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPaperDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfPaperDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPaperDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPaperDto {
    totalCount: number | undefined;
    items: PaperDto[] | undefined;
}

export class PaperCreateInput implements IPaperCreateInput {
    region!: string | undefined;
    department!: string | undefined;
    no!: string | undefined;
    chineseTitle!: string | undefined;
    englishTitle!: string | undefined;
    adviser!: string | undefined;
    academicYear!: string | undefined;
    publicationYear!: string | undefined;
    url!: string | undefined;

    constructor(data?: IPaperCreateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.region = data["region"];
            this.department = data["department"];
            this.no = data["no"];
            this.chineseTitle = data["chineseTitle"];
            this.englishTitle = data["englishTitle"];
            this.adviser = data["adviser"];
            this.academicYear = data["academicYear"];
            this.publicationYear = data["publicationYear"];
            this.url = data["url"];
        }
    }

    static fromJS(data: any): PaperCreateInput {
        data = typeof data === 'object' ? data : {};
        let result = new PaperCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["region"] = this.region;
        data["department"] = this.department;
        data["no"] = this.no;
        data["chineseTitle"] = this.chineseTitle;
        data["englishTitle"] = this.englishTitle;
        data["adviser"] = this.adviser;
        data["academicYear"] = this.academicYear;
        data["publicationYear"] = this.publicationYear;
        data["url"] = this.url;
        return data; 
    }

    clone(): PaperCreateInput {
        const json = this.toJSON();
        let result = new PaperCreateInput();
        result.init(json);
        return result;
    }
}

export interface IPaperCreateInput {
    region: string | undefined;
    department: string | undefined;
    no: string | undefined;
    chineseTitle: string | undefined;
    englishTitle: string | undefined;
    adviser: string | undefined;
    academicYear: string | undefined;
    publicationYear: string | undefined;
    url: string | undefined;
}

export class PagedResultDtoOfPatentDto implements IPagedResultDtoOfPatentDto {
    totalCount!: number | undefined;
    items!: PatentDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPatentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(PatentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPatentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPatentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfPatentDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPatentDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPatentDto {
    totalCount: number | undefined;
    items: PatentDto[] | undefined;
}

export class PatentDto implements IPatentDto {
    professorId!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    country!: string | undefined;
    serialNumber!: string | undefined;
    validStartTime!: Date | undefined;
    validEndTime!: Date | undefined;
    valueYear!: string | undefined;
    comment!: string | undefined;
    item!: string | undefined;
    patentNo!: string | undefined;
    owners!: string | undefined;
    saleMethod!: string | undefined;
    applyNo!: string | undefined;
    applyDate!: string | undefined;
    patentee!: string | undefined;
    ipc!: string | undefined;
    description!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IPatentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professorId = data["professorId"];
            this.name = data["name"];
            this.type = data["type"];
            this.country = data["country"];
            this.serialNumber = data["serialNumber"];
            this.validStartTime = data["validStartTime"] ? new Date(data["validStartTime"].toString()) : <any>undefined;
            this.validEndTime = data["validEndTime"] ? new Date(data["validEndTime"].toString()) : <any>undefined;
            this.valueYear = data["valueYear"];
            this.comment = data["comment"];
            this.item = data["item"];
            this.patentNo = data["patentNo"];
            this.owners = data["owners"];
            this.saleMethod = data["saleMethod"];
            this.applyNo = data["applyNo"];
            this.applyDate = data["applyDate"];
            this.patentee = data["patentee"];
            this.ipc = data["ipc"];
            this.description = data["description"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PatentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professorId"] = this.professorId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["country"] = this.country;
        data["serialNumber"] = this.serialNumber;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : <any>undefined;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : <any>undefined;
        data["valueYear"] = this.valueYear;
        data["comment"] = this.comment;
        data["item"] = this.item;
        data["patentNo"] = this.patentNo;
        data["owners"] = this.owners;
        data["saleMethod"] = this.saleMethod;
        data["applyNo"] = this.applyNo;
        data["applyDate"] = this.applyDate;
        data["patentee"] = this.patentee;
        data["ipc"] = this.ipc;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PatentDto {
        const json = this.toJSON();
        let result = new PatentDto();
        result.init(json);
        return result;
    }
}

export interface IPatentDto {
    professorId: string | undefined;
    name: string | undefined;
    type: string | undefined;
    country: string | undefined;
    serialNumber: string | undefined;
    validStartTime: Date | undefined;
    validEndTime: Date | undefined;
    valueYear: string | undefined;
    comment: string | undefined;
    item: string | undefined;
    patentNo: string | undefined;
    owners: string | undefined;
    saleMethod: string | undefined;
    applyNo: string | undefined;
    applyDate: string | undefined;
    patentee: string | undefined;
    ipc: string | undefined;
    description: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class PostGetPatentUrl implements IPostGetPatentUrl {
    professorId!: string | undefined;
    patentName!: string | undefined;

    constructor(data?: IPostGetPatentUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professorId = data["professorId"];
            this.patentName = data["patentName"];
        }
    }

    static fromJS(data: any): PostGetPatentUrl {
        data = typeof data === 'object' ? data : {};
        let result = new PostGetPatentUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professorId"] = this.professorId;
        data["patentName"] = this.patentName;
        return data; 
    }

    clone(): PostGetPatentUrl {
        const json = this.toJSON();
        let result = new PostGetPatentUrl();
        result.init(json);
        return result;
    }
}

export interface IPostGetPatentUrl {
    professorId: string | undefined;
    patentName: string | undefined;
}

export class PatentCreateInput implements IPatentCreateInput {
    professorId!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    country!: string | undefined;
    serialNumber!: string | undefined;
    validStartTime!: Date | undefined;
    validEndTime!: Date | undefined;
    valueYear!: string | undefined;
    comment!: string | undefined;
    item!: string | undefined;
    patentNo!: string | undefined;
    owners!: string | undefined;
    saleMethod!: string | undefined;
    applyNo!: string | undefined;
    applyDate!: string | undefined;
    patentee!: string | undefined;
    ipc!: string | undefined;
    description!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;

    constructor(data?: IPatentCreateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professorId = data["professorId"];
            this.name = data["name"];
            this.type = data["type"];
            this.country = data["country"];
            this.serialNumber = data["serialNumber"];
            this.validStartTime = data["validStartTime"] ? new Date(data["validStartTime"].toString()) : <any>undefined;
            this.validEndTime = data["validEndTime"] ? new Date(data["validEndTime"].toString()) : <any>undefined;
            this.valueYear = data["valueYear"];
            this.comment = data["comment"];
            this.item = data["item"];
            this.patentNo = data["patentNo"];
            this.owners = data["owners"];
            this.saleMethod = data["saleMethod"];
            this.applyNo = data["applyNo"];
            this.applyDate = data["applyDate"];
            this.patentee = data["patentee"];
            this.ipc = data["ipc"];
            this.description = data["description"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
        }
    }

    static fromJS(data: any): PatentCreateInput {
        data = typeof data === 'object' ? data : {};
        let result = new PatentCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professorId"] = this.professorId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["country"] = this.country;
        data["serialNumber"] = this.serialNumber;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : <any>undefined;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : <any>undefined;
        data["valueYear"] = this.valueYear;
        data["comment"] = this.comment;
        data["item"] = this.item;
        data["patentNo"] = this.patentNo;
        data["owners"] = this.owners;
        data["saleMethod"] = this.saleMethod;
        data["applyNo"] = this.applyNo;
        data["applyDate"] = this.applyDate;
        data["patentee"] = this.patentee;
        data["ipc"] = this.ipc;
        data["description"] = this.description;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data; 
    }

    clone(): PatentCreateInput {
        const json = this.toJSON();
        let result = new PatentCreateInput();
        result.init(json);
        return result;
    }
}

export interface IPatentCreateInput {
    professorId: string | undefined;
    name: string | undefined;
    type: string | undefined;
    country: string | undefined;
    serialNumber: string | undefined;
    validStartTime: Date | undefined;
    validEndTime: Date | undefined;
    valueYear: string | undefined;
    comment: string | undefined;
    item: string | undefined;
    patentNo: string | undefined;
    owners: string | undefined;
    saleMethod: string | undefined;
    applyNo: string | undefined;
    applyDate: string | undefined;
    patentee: string | undefined;
    ipc: string | undefined;
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
}

export class PatentWithDetailsDto implements IPatentWithDetailsDto {
    professor!: ProfessorDto | undefined;
    professorId!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    country!: string | undefined;
    serialNumber!: string | undefined;
    validStartTime!: Date | undefined;
    validEndTime!: Date | undefined;
    valueYear!: string | undefined;
    comment!: string | undefined;
    item!: string | undefined;
    patentNo!: string | undefined;
    owners!: string | undefined;
    saleMethod!: string | undefined;
    applyNo!: string | undefined;
    applyDate!: string | undefined;
    patentee!: string | undefined;
    ipc!: string | undefined;
    description!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IPatentWithDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professor = data["professor"] ? ProfessorDto.fromJS(data["professor"]) : <any>undefined;
            this.professorId = data["professorId"];
            this.name = data["name"];
            this.type = data["type"];
            this.country = data["country"];
            this.serialNumber = data["serialNumber"];
            this.validStartTime = data["validStartTime"] ? new Date(data["validStartTime"].toString()) : <any>undefined;
            this.validEndTime = data["validEndTime"] ? new Date(data["validEndTime"].toString()) : <any>undefined;
            this.valueYear = data["valueYear"];
            this.comment = data["comment"];
            this.item = data["item"];
            this.patentNo = data["patentNo"];
            this.owners = data["owners"];
            this.saleMethod = data["saleMethod"];
            this.applyNo = data["applyNo"];
            this.applyDate = data["applyDate"];
            this.patentee = data["patentee"];
            this.ipc = data["ipc"];
            this.description = data["description"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PatentWithDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatentWithDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professor"] = this.professor ? this.professor.toJSON() : <any>undefined;
        data["professorId"] = this.professorId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["country"] = this.country;
        data["serialNumber"] = this.serialNumber;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : <any>undefined;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : <any>undefined;
        data["valueYear"] = this.valueYear;
        data["comment"] = this.comment;
        data["item"] = this.item;
        data["patentNo"] = this.patentNo;
        data["owners"] = this.owners;
        data["saleMethod"] = this.saleMethod;
        data["applyNo"] = this.applyNo;
        data["applyDate"] = this.applyDate;
        data["patentee"] = this.patentee;
        data["ipc"] = this.ipc;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): PatentWithDetailsDto {
        const json = this.toJSON();
        let result = new PatentWithDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IPatentWithDetailsDto {
    professor: ProfessorDto | undefined;
    professorId: string | undefined;
    name: string | undefined;
    type: string | undefined;
    country: string | undefined;
    serialNumber: string | undefined;
    validStartTime: Date | undefined;
    validEndTime: Date | undefined;
    valueYear: string | undefined;
    comment: string | undefined;
    item: string | undefined;
    patentNo: string | undefined;
    owners: string | undefined;
    saleMethod: string | undefined;
    applyNo: string | undefined;
    applyDate: string | undefined;
    patentee: string | undefined;
    ipc: string | undefined;
    description: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class PatentUpdateInput implements IPatentUpdateInput {
    professorId!: string | undefined;
    name!: string | undefined;
    type!: string | undefined;
    country!: string | undefined;
    serialNumber!: string | undefined;
    validStartTime!: Date | undefined;
    validEndTime!: Date | undefined;
    valueYear!: string | undefined;
    comment!: string | undefined;
    item!: string | undefined;
    patentNo!: string | undefined;
    owners!: string | undefined;
    saleMethod!: string | undefined;
    applyNo!: string | undefined;
    applyDate!: string | undefined;
    patentee!: string | undefined;
    ipc!: string | undefined;
    description!: string | undefined;
    startTime!: string | undefined;
    endTime!: string | undefined;

    constructor(data?: IPatentUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professorId = data["professorId"];
            this.name = data["name"];
            this.type = data["type"];
            this.country = data["country"];
            this.serialNumber = data["serialNumber"];
            this.validStartTime = data["validStartTime"] ? new Date(data["validStartTime"].toString()) : <any>undefined;
            this.validEndTime = data["validEndTime"] ? new Date(data["validEndTime"].toString()) : <any>undefined;
            this.valueYear = data["valueYear"];
            this.comment = data["comment"];
            this.item = data["item"];
            this.patentNo = data["patentNo"];
            this.owners = data["owners"];
            this.saleMethod = data["saleMethod"];
            this.applyNo = data["applyNo"];
            this.applyDate = data["applyDate"];
            this.patentee = data["patentee"];
            this.ipc = data["ipc"];
            this.description = data["description"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
        }
    }

    static fromJS(data: any): PatentUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new PatentUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professorId"] = this.professorId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["country"] = this.country;
        data["serialNumber"] = this.serialNumber;
        data["validStartTime"] = this.validStartTime ? this.validStartTime.toISOString() : <any>undefined;
        data["validEndTime"] = this.validEndTime ? this.validEndTime.toISOString() : <any>undefined;
        data["valueYear"] = this.valueYear;
        data["comment"] = this.comment;
        data["item"] = this.item;
        data["patentNo"] = this.patentNo;
        data["owners"] = this.owners;
        data["saleMethod"] = this.saleMethod;
        data["applyNo"] = this.applyNo;
        data["applyDate"] = this.applyDate;
        data["patentee"] = this.patentee;
        data["ipc"] = this.ipc;
        data["description"] = this.description;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data; 
    }

    clone(): PatentUpdateInput {
        const json = this.toJSON();
        let result = new PatentUpdateInput();
        result.init(json);
        return result;
    }
}

export interface IPatentUpdateInput {
    professorId: string | undefined;
    name: string | undefined;
    type: string | undefined;
    country: string | undefined;
    serialNumber: string | undefined;
    validStartTime: Date | undefined;
    validEndTime: Date | undefined;
    valueYear: string | undefined;
    comment: string | undefined;
    item: string | undefined;
    patentNo: string | undefined;
    owners: string | undefined;
    saleMethod: string | undefined;
    applyNo: string | undefined;
    applyDate: string | undefined;
    patentee: string | undefined;
    ipc: string | undefined;
    description: string | undefined;
    startTime: string | undefined;
    endTime: string | undefined;
}

export class PagedResultDtoOfProfessorDto implements IPagedResultDtoOfProfessorDto {
    totalCount!: number | undefined;
    items!: ProfessorDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProfessorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ProfessorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProfessorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProfessorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfProfessorDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProfessorDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProfessorDto {
    totalCount: number | undefined;
    items: ProfessorDto[] | undefined;
}

export class ProfessorWithDetailsDto implements IProfessorWithDetailsDto {
    projects!: ProjectDto[] | undefined;
    patents!: PatentDto[] | undefined;
    professorPapers!: ProfessorPaperDto[] | undefined;
    collegeId!: string | undefined;
    departmentId!: string | undefined;
    classifyId!: string | undefined;
    titleId!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    extension!: string | undefined;
    fax!: string | undefined;
    email!: string | undefined;
    specialized!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IProfessorWithDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["projects"])) {
                this.projects = [] as any;
                for (let item of data["projects"])
                    this.projects!.push(ProjectDto.fromJS(item));
            }
            if (Array.isArray(data["patents"])) {
                this.patents = [] as any;
                for (let item of data["patents"])
                    this.patents!.push(PatentDto.fromJS(item));
            }
            if (Array.isArray(data["professorPapers"])) {
                this.professorPapers = [] as any;
                for (let item of data["professorPapers"])
                    this.professorPapers!.push(ProfessorPaperDto.fromJS(item));
            }
            this.collegeId = data["collegeId"];
            this.departmentId = data["departmentId"];
            this.classifyId = data["classifyId"];
            this.titleId = data["titleId"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.extension = data["extension"];
            this.fax = data["fax"];
            this.email = data["email"];
            this.specialized = data["specialized"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProfessorWithDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessorWithDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.patents)) {
            data["patents"] = [];
            for (let item of this.patents)
                data["patents"].push(item.toJSON());
        }
        if (Array.isArray(this.professorPapers)) {
            data["professorPapers"] = [];
            for (let item of this.professorPapers)
                data["professorPapers"].push(item.toJSON());
        }
        data["collegeId"] = this.collegeId;
        data["departmentId"] = this.departmentId;
        data["classifyId"] = this.classifyId;
        data["titleId"] = this.titleId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["specialized"] = this.specialized;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProfessorWithDetailsDto {
        const json = this.toJSON();
        let result = new ProfessorWithDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IProfessorWithDetailsDto {
    projects: ProjectDto[] | undefined;
    patents: PatentDto[] | undefined;
    professorPapers: ProfessorPaperDto[] | undefined;
    collegeId: string | undefined;
    departmentId: string | undefined;
    classifyId: string | undefined;
    titleId: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    extension: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    specialized: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class ProjectDto implements IProjectDto {
    professorId!: string | undefined;
    name!: string | undefined;
    comment!: string | undefined;
    year!: string | undefined;
    no!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    type!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professorId = data["professorId"];
            this.name = data["name"];
            this.comment = data["comment"];
            this.year = data["year"];
            this.no = data["no"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.type = data["type"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professorId"] = this.professorId;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["year"] = this.year;
        data["no"] = this.no;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProjectDto {
        const json = this.toJSON();
        let result = new ProjectDto();
        result.init(json);
        return result;
    }
}

export interface IProjectDto {
    professorId: string | undefined;
    name: string | undefined;
    comment: string | undefined;
    year: string | undefined;
    no: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    type: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class ProfessorUpdateInput implements IProfessorUpdateInput {
    collegeId!: string | undefined;
    departmentId!: string | undefined;
    classifyId!: string | undefined;
    titleId!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    extension!: string | undefined;
    fax!: string | undefined;
    email!: string | undefined;
    specialized!: string | undefined;

    constructor(data?: IProfessorUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collegeId = data["collegeId"];
            this.departmentId = data["departmentId"];
            this.classifyId = data["classifyId"];
            this.titleId = data["titleId"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.extension = data["extension"];
            this.fax = data["fax"];
            this.email = data["email"];
            this.specialized = data["specialized"];
        }
    }

    static fromJS(data: any): ProfessorUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessorUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collegeId"] = this.collegeId;
        data["departmentId"] = this.departmentId;
        data["classifyId"] = this.classifyId;
        data["titleId"] = this.titleId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["specialized"] = this.specialized;
        return data; 
    }

    clone(): ProfessorUpdateInput {
        const json = this.toJSON();
        let result = new ProfessorUpdateInput();
        result.init(json);
        return result;
    }
}

export interface IProfessorUpdateInput {
    collegeId: string | undefined;
    departmentId: string | undefined;
    classifyId: string | undefined;
    titleId: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    extension: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    specialized: string | undefined;
}

export class ProfessorCreateInput implements IProfessorCreateInput {
    collegeId!: string | undefined;
    departmentId!: string | undefined;
    classifyId!: string | undefined;
    titleId!: string | undefined;
    name!: string | undefined;
    phone!: string | undefined;
    extension!: string | undefined;
    fax!: string | undefined;
    email!: string | undefined;
    specialized!: string | undefined;

    constructor(data?: IProfessorCreateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.collegeId = data["collegeId"];
            this.departmentId = data["departmentId"];
            this.classifyId = data["classifyId"];
            this.titleId = data["titleId"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.extension = data["extension"];
            this.fax = data["fax"];
            this.email = data["email"];
            this.specialized = data["specialized"];
        }
    }

    static fromJS(data: any): ProfessorCreateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessorCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collegeId"] = this.collegeId;
        data["departmentId"] = this.departmentId;
        data["classifyId"] = this.classifyId;
        data["titleId"] = this.titleId;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["extension"] = this.extension;
        data["fax"] = this.fax;
        data["email"] = this.email;
        data["specialized"] = this.specialized;
        return data; 
    }

    clone(): ProfessorCreateInput {
        const json = this.toJSON();
        let result = new ProfessorCreateInput();
        result.init(json);
        return result;
    }
}

export interface IProfessorCreateInput {
    collegeId: string | undefined;
    departmentId: string | undefined;
    classifyId: string | undefined;
    titleId: string | undefined;
    name: string | undefined;
    phone: string | undefined;
    extension: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    specialized: string | undefined;
}

export class PagedResultDtoOfProjectDto implements IPagedResultDtoOfProjectDto {
    totalCount!: number | undefined;
    items!: ProjectDto[] | undefined;

    constructor(data?: IPagedResultDtoOfProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(ProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfProjectDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfProjectDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfProjectDto {
    totalCount: number | undefined;
    items: ProjectDto[] | undefined;
}

export class PagedResultDtoOfGetNoRelationProjectsOutput implements IPagedResultDtoOfGetNoRelationProjectsOutput {
    totalCount!: number | undefined;
    items!: GetNoRelationProjectsOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetNoRelationProjectsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (Array.isArray(data["items"])) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(GetNoRelationProjectsOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetNoRelationProjectsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetNoRelationProjectsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetNoRelationProjectsOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetNoRelationProjectsOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetNoRelationProjectsOutput {
    totalCount: number | undefined;
    items: GetNoRelationProjectsOutput[] | undefined;
}

export class GetNoRelationProjectsOutput implements IGetNoRelationProjectsOutput {
    extraProfessor!: string | undefined;
    professorId!: string | undefined;
    name!: string | undefined;
    comment!: string | undefined;
    year!: string | undefined;
    no!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    type!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IGetNoRelationProjectsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extraProfessor = data["extraProfessor"];
            this.professorId = data["professorId"];
            this.name = data["name"];
            this.comment = data["comment"];
            this.year = data["year"];
            this.no = data["no"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.type = data["type"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetNoRelationProjectsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNoRelationProjectsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extraProfessor"] = this.extraProfessor;
        data["professorId"] = this.professorId;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["year"] = this.year;
        data["no"] = this.no;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): GetNoRelationProjectsOutput {
        const json = this.toJSON();
        let result = new GetNoRelationProjectsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetNoRelationProjectsOutput {
    extraProfessor: string | undefined;
    professorId: string | undefined;
    name: string | undefined;
    comment: string | undefined;
    year: string | undefined;
    no: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    type: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class ProjectWithDetailsDto implements IProjectWithDetailsDto {
    professor!: ProfessorDto | undefined;
    professorId!: string | undefined;
    name!: string | undefined;
    comment!: string | undefined;
    year!: string | undefined;
    no!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    type!: string | undefined;
    isDeleted!: boolean | undefined;
    deleterId!: string | undefined;
    deletionTime!: Date | undefined;
    lastModificationTime!: Date | undefined;
    lastModifierId!: string | undefined;
    creationTime!: Date | undefined;
    creatorId!: string | undefined;
    id!: string | undefined;

    constructor(data?: IProjectWithDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professor = data["professor"] ? ProfessorDto.fromJS(data["professor"]) : <any>undefined;
            this.professorId = data["professorId"];
            this.name = data["name"];
            this.comment = data["comment"];
            this.year = data["year"];
            this.no = data["no"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.type = data["type"];
            this.isDeleted = data["isDeleted"];
            this.deleterId = data["deleterId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierId = data["lastModifierId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorId = data["creatorId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ProjectWithDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectWithDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professor"] = this.professor ? this.professor.toJSON() : <any>undefined;
        data["professorId"] = this.professorId;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["year"] = this.year;
        data["no"] = this.no;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["isDeleted"] = this.isDeleted;
        data["deleterId"] = this.deleterId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierId"] = this.lastModifierId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorId"] = this.creatorId;
        data["id"] = this.id;
        return data; 
    }

    clone(): ProjectWithDetailsDto {
        const json = this.toJSON();
        let result = new ProjectWithDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IProjectWithDetailsDto {
    professor: ProfessorDto | undefined;
    professorId: string | undefined;
    name: string | undefined;
    comment: string | undefined;
    year: string | undefined;
    no: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    type: string | undefined;
    isDeleted: boolean | undefined;
    deleterId: string | undefined;
    deletionTime: Date | undefined;
    lastModificationTime: Date | undefined;
    lastModifierId: string | undefined;
    creationTime: Date | undefined;
    creatorId: string | undefined;
    id: string | undefined;
}

export class ProjectUpdateInput implements IProjectUpdateInput {
    professorId!: string | undefined;
    name!: string | undefined;
    comment!: string | undefined;
    year!: string | undefined;
    no!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    type!: string | undefined;

    constructor(data?: IProjectUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professorId = data["professorId"];
            this.name = data["name"];
            this.comment = data["comment"];
            this.year = data["year"];
            this.no = data["no"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.type = data["type"];
        }
    }

    static fromJS(data: any): ProjectUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professorId"] = this.professorId;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["year"] = this.year;
        data["no"] = this.no;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data; 
    }

    clone(): ProjectUpdateInput {
        const json = this.toJSON();
        let result = new ProjectUpdateInput();
        result.init(json);
        return result;
    }
}

export interface IProjectUpdateInput {
    professorId: string | undefined;
    name: string | undefined;
    comment: string | undefined;
    year: string | undefined;
    no: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    type: string | undefined;
}

export class ProjectCreateInput implements IProjectCreateInput {
    professorId!: string | undefined;
    name!: string | undefined;
    comment!: string | undefined;
    year!: string | undefined;
    no!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    type!: string | undefined;

    constructor(data?: IProjectCreateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.professorId = data["professorId"];
            this.name = data["name"];
            this.comment = data["comment"];
            this.year = data["year"];
            this.no = data["no"];
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.type = data["type"];
        }
    }

    static fromJS(data: any): ProjectCreateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCreateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["professorId"] = this.professorId;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["year"] = this.year;
        data["no"] = this.no;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        return data; 
    }

    clone(): ProjectCreateInput {
        const json = this.toJSON();
        let result = new ProjectCreateInput();
        result.init(json);
        return result;
    }
}

export interface IProjectCreateInput {
    professorId: string | undefined;
    name: string | undefined;
    comment: string | undefined;
    year: string | undefined;
    no: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    type: string | undefined;
}

export class SampleDto implements ISampleDto {
    value!: number | undefined;

    constructor(data?: ISampleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
        }
    }

    static fromJS(data: any): SampleDto {
        data = typeof data === 'object' ? data : {};
        let result = new SampleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data; 
    }

    clone(): SampleDto {
        const json = this.toJSON();
        let result = new SampleDto();
        result.init(json);
        return result;
    }
}

export interface ISampleDto {
    value: number | undefined;
}

export enum Type {
    校區 = 0,
    學院 = 1,
    系所 = 2,
    領域 = 3,
    職稱 = 4,
}

export enum CodeType {
    校區 = 0,
    學院 = 1,
    系所 = 2,
    領域 = 3,
    職稱 = 4,
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}